export const tabs = {
	productDetails: {
		label: "Product details",
		title: "Product details",
		subtitle: "General information, pricing and stock",
	},
	storages: {
		label: "Storages",
		title: "Storages",
		subtitle: "See all storages this product is linked to",
		table: {
			empty: "No linked storage",
			columns: {
				storage: "Storage",
			},
		},
	},
	kardex: {
		label: "Kardex sheet",
		title: "Kardex sheet",
		subtitle: "The Kardex sheet represents item stock and movements.",
	},
	fiscalData: {
		label: "Fiscal data",
		title: "Fiscal data",
		subtitle: "Product fiscal information",
	},
	technicalSheet: {
		label: "Technical sheet",
		title: "Technical sheet",
		subtitle: "Product composition and ingredients",
	},
	bars: {
		label: "Bars",
		title: "Bars",
		subtitle: "Bars and sectors settings",
	},
	mountableProduct: {
		label: "Mountable product",
		title: "Mountable product",
		subtitle:
			"Mountable products allow the end customer to create a combination from a fixed base and a variety of additional ingredients. In the case of açaí, for example, the base would be blended açaí and the additional ingredients would be peanut brittle, milk powder, etc.",
	},
	qrcode: {
		label: "QR Code",
		title: "QR Code",
	},
};
